import { notifications } from '@mantine/notifications';
import {
  getTourCategoriesKey,
  useCreateTourCategory,
} from 'api-hooks/tour-category';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import TourCategoryForm from './components/form';

export default function TourCategoryCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateTourCategory();
  const permission = useGetCrudPermission('tour-categories');

  return (
    <TourCategoryForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(getTourCategoriesKey());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.TourCategoryView, {
            id: result.data?.id,
          });
        }
        notifications.show({ message: result?.message, color: 'green' });
        return result.data;
      }}
    />
  );
}
